
<template>
  <main>
    <fade-in-top-title class="title-interval">
      <h3>Webアプリ試作<br>Google Apps Script</h3>
      <span>Google Apps Script</span>
    </fade-in-top-title>
    <div class="container container-work">
      <fade-in-main>
        <img src="@/assets/images/workContents05.png" alt="">
      </fade-in-main>
      <work-contents-text-me
      webSiteText="google Apps ScriptとHTMLを連携させたWebアプリになります。"
      webSiteTextContentsFirst="Webアプリ側で項目(「開始終了日付」「開始終了時間」「備考」)を入力して送信すると、googleスプレッドシートにデータが保持されて、googleカレンダーに予定として反映されます。"/>
      <div class="work-contents-wrapper">
        <work-contents-block title="フローチャート">
        <img src="@/assets/images/workContents05-00_flow-chart.png" alt="" class="img-flow-chart">
        </work-contents-block>
        <work-contents-block title="①項目を入力して送信すると、googleスプレッドシートに反映される挙動はこちら">
        <div class="gif" @click="gifClick01">
          <img :src="gif01.src" alt="" :id="1">
          <play-icon v-show="show01"></play-icon>
        </div>
        </work-contents-block>
        <work-contents-block title="②googleカレンダーに反映される挙動はこちら">
        <div class="gif" @click="gifClick02">
          <img :src="gif02.src" alt="" :id="2">
          <play-icon v-show="show02"></play-icon>
        </div>
        </work-contents-block>
      </div>
    </div>
    <router-link to="/work/workContents04">
      <work-slide-left></work-slide-left>
    </router-link>
    <router-link to="/work/workContents06">
      <work-slide-right></work-slide-right>
    </router-link>
  </main>
</template>



<script>
import FadeInMain from '@/components/FadeInMain.vue';
import FadeInTopTitle from '@/components/FadeInTopTitle.vue';
import WorkContentsTextMe from '@/components/WorkContentsTextMe.vue';
import WorkContentsBlock from '@/components/WorkContentsBlock.vue';
import WorkSlideLeft from '@/components/WorkSlideLeft.vue';
import WorkSlideRight from '@/components/WorkSlideRight.vue';
import PlayIcon from '@/components/PlayIcon.vue';

export default {
  data() {
    return {
      gif01: {
        src: require('@/assets/gifs/gas01_play.gif')
      },
      gif02: {
        src: require('@/assets/gifs/gas02_play.gif')
      },
      show01: true,
      show02: true,
    }
  },
  components: {
    FadeInMain,
    FadeInTopTitle,
    WorkContentsTextMe,
    WorkContentsBlock,
    WorkSlideLeft,
    WorkSlideRight,
    PlayIcon
  },
  methods: {
    gifClick01() {
      this.show01 = !this.show01;
      if(this.show01) {
        this.gif01.src = require('@/assets/gifs/gas01_play.gif');
      } else {
      this.gif01.src = require('@/assets/gifs/gas01.gif');
      }
    },
    gifClick02() {
      this.show02 = !this.show02;
      if(this.show02) {
        this.gif02.src = require('@/assets/gifs/gas02_play.gif');
      } else {
      this.gif02.src = require('@/assets/gifs/gas02.gif');
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.img-flow-chart {
  width: 80%;
}
.gif {
  position: relative;
  img {
    width: 60%;
  }
}

</style>